import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

export default function CTABannerSection() {
  return (
    <section className="py-24 bg-background">
      <div className="max-w-container mx-auto px-6 md:px-12">
        <div className="relative bg-gray-900 rounded-organic-xl overflow-hidden min-h-[400px] flex items-center reveal">
          {/* Background Image with Overlay */}
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-20"
            style={{
              backgroundImage: "url('https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1600&h=800&fit=crop')"
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-gray-900/90 to-transparent" />

          {/* Content */}
          <div className="relative z-10 max-w-3xl px-8 md:px-16 py-16">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-white/80 mb-4">
              Start Your Partnership
            </span>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 leading-tight">
              Ready to Get Started?
            </h2>

            <p className="text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl">
              Get a custom quote for your bulk order today. Our team is standing by to help you find the perfect supply solution for your business.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                href="/contact"
                className="btn-scale inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-8 py-4 rounded-full text-base font-semibold hover:bg-primary/90 shadow-lg"
              >
                Request Quote Now
                <Icon name="ArrowUpRightIcon" size={20} className="arrow-shift" />
              </Link>
              
              <Link
                href="/products"
                className="btn-scale inline-flex items-center justify-center gap-2 border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-gray-900"
              >
                Browse Products
                <Icon name="ArrowRightIcon" size={20} className="arrow-shift" />
              </Link>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-6 mt-10 pt-10 border-t border-white/20">
              <div className="flex items-center gap-2 text-sm text-white/80">
                <Icon name="CheckCircleIcon" size={20} className="text-primary" />
                <span>ISO Certified</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/80">
                <Icon name="CheckCircleIcon" size={20} className="text-primary" />
                <span>Global Shipping</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/80">
                <Icon name="CheckCircleIcon" size={20} className="text-primary" />
                <span>24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}